import { createProviderToken } from '@core/common-legacy';

export interface TellentMobileSheetHandle {
  present: () => Promise<void>;
  dismiss: (data?: unknown, role?: string) => Promise<boolean>;
  onWillDismiss: <T = unknown>() => Promise<{ data?: T; role?: string }>;
}

export interface TellentMobileSheetOptions {
  component: unknown;
  componentProps?: Record<string, unknown>;
  canDismiss?: boolean;
  // Sheet chrome behind the component: 'default' matches the confirmation
  // sheet (plain surface), 'neutral' the options sheet (grouped cards on a
  // neutral surface). Presenters map this to their own overlay mechanism.
  background?: 'default' | 'neutral';
}

export interface TellentMobileSheetPresenter {
  createSheet: (options: TellentMobileSheetOptions) => Promise<TellentMobileSheetHandle>;
}

export const {
  provide: provideTellentMobileSheetPresenter,
  inject: injectTellentMobileSheetPresenter,
} = createProviderToken<TellentMobileSheetPresenter>('TELLENT_MOBILE_SHEET_PRESENTER')(false);
